// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root___z1TG","inner":"Footer_inner__ngCVB","group":"Footer_group__jSsXQ","links":"Footer_links__13oK3"};